<script lang="ts">
	import { Route } from "svelte-navigator";
	import PrivateRouteGuard from "./PrivateRouteGuard.svelte";

	export let path: string;
	export let optional: boolean = false;
	export let needsPlan: boolean = false;
</script>

<Route {path} let:params let:location let:navigate>
	<PrivateRouteGuard {optional} {needsPlan}>
		<slot {params} {location} {navigate} />
	</PrivateRouteGuard>
</Route>
